module.exports = __webpack_public_path__ + "static/media/Medhansh.0fc78125.mp3";